export default __webpack_public_path__ + "static/media/Isabella 9781408304754.0984cd2e.jpg";